/**
 * @generated SignedSource<<32d0f95854f22bda290f1a2cbcbb9639>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_SidebarLayout_view$data = {
  readonly " $fragmentSpreads": FragmentRefs<"experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_view">;
  readonly " $fragmentType": "main_issueNavigator_SidebarLayout_view";
};
export type main_issueNavigator_SidebarLayout_view$key = {
  readonly " $data"?: main_issueNavigator_SidebarLayout_view$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_SidebarLayout_view">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isSavedViewConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "main_issueNavigator_SidebarLayout_view",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isSavedViewConditionalFormattingEnabled",
          "variableName": "isSavedViewConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_view"
    }
  ],
  "type": "JiraSpreadsheetView",
  "abstractKey": "__isJiraSpreadsheetView"
};

(node as any).hash = "f9655b70707eaa7da316ffe24682274f";

export default node;
